import React, { useEffect } from "react";
import { useLocation, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import B2BNavbar from "../components/B2BNavbar";
import AdminSidebar from "../components/AdminSidebar";
import GeoBanner from "../components/GeoBanner";
import CartDrawer from "../components/CartDrawer";
import WhatsAppFab from "../components/WhatsAppFab";

export function PublicLayout() {
  const loc = useLocation();
  useEffect(() => { document.body.className = ""; }, [loc.pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      <GeoBanner />
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <CartDrawer />
      <WhatsAppFab />
    </div>
  );
}

export function B2BLayout() {
  const { user } = useAuth();
  useEffect(() => {
    document.body.className = "theme-b2b";
    return () => { document.body.className = ""; };
  }, []);
  const pending = user && user.role === "buyer" && !user.verified;
  return (
    <div className="min-h-screen flex flex-col bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
      <B2BNavbar />
      {pending && (
        <div data-testid="b2b-pending-banner" className="bg-[hsl(var(--accent))]/15 border-b border-[hsl(var(--accent))]/40 text-sm">
          <div className="container-xl py-3 flex items-center gap-3 text-[hsl(var(--accent))]">
            <span className="inline-block h-2 w-2 rounded-full bg-[hsl(var(--accent))] animate-pulse" />
            <span>Il tuo account B2B è <strong>in attesa di verifica</strong>. Sbloccherai prezzi pallet e preventivi una volta approvato dal nostro team.</span>
          </div>
        </div>
      )}
      <main className="flex-1"><Outlet /></main>
      <CartDrawer />
    </div>
  );
}

export function AdminLayout() {
  const { user } = useAuth();
  useEffect(() => {
    document.body.className = "theme-admin";
    return () => { document.body.className = ""; };
  }, []);
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "super_admin") return <div className="p-10">Area riservata. Ruolo richiesto: super_admin.</div>;
  return (
    <div className="min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
      <AdminSidebar />
      <main className="lg:ml-[260px] p-4 sm:p-6 md:p-10"><Outlet /></main>
    </div>
  );
}
